export const normalizePuntoVentaText = value =>
  `${value || ""}`
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const getConfiguredPuntosDeVenta = value => {
  if (!Array.isArray(value)) return [];

  return value.map(item => `${item || ""}`.trim()).filter(Boolean);
};

export const getPuntosDeVentaOptions = puntosDeVenta =>
  getConfiguredPuntosDeVenta(puntosDeVenta).map(puntoVenta => ({
    label: puntoVenta,
    value: puntoVenta
  }));

export const getPuntoVentaAutocompleteValue = (options, puntoVenta) =>
  options.find(option => option.value === puntoVenta) || null;

export const isValidConfiguredPuntoVenta = (options, puntoVenta) => {
  const normalizedPuntoVenta = normalizePuntoVentaText(puntoVenta);

  if (!normalizedPuntoVenta) return false;

  return options.some(
    option => normalizePuntoVentaText(option.value) === normalizedPuntoVenta
  );
};

export const isProductCompatibleWithPuntoVenta = (product, puntoVenta) => {
  const normalizedPuntoVenta = normalizePuntoVentaText(puntoVenta);

  if (!normalizedPuntoVenta) return true;

  const searchableValues = [product && product.nombre, product && product.label];

  return searchableValues.some(value =>
    normalizePuntoVentaText(value).includes(normalizedPuntoVenta)
  );
};

export const filterProductsByPuntoVenta = (products, puntoVenta) => {
  if (!puntoVenta) return products;

  return products.filter(product =>
    isProductCompatibleWithPuntoVenta(product, puntoVenta)
  );
};

export const hasProductsIncompatibleWithPuntoVenta = (products, puntoVenta) =>
  filterProductsByPuntoVenta(products, puntoVenta).length !== products.length;
